export const hasTemplateTags = (htmlString: string): boolean =>
  /\{[A-Z_]+\}/i.test(htmlString);
